import { clsx } from "@trydig/ui";
import type { PropsWithChildren } from "react";
import styles from "./ProductGrid.module.css";

export const ProductGrid = ({ children }: PropsWithChildren) => {
	return (
		<div className={styles["grid-container"]}>
			<div className={clsx(styles.grid, "product-grid")}>{children}</div>
		</div>
	);
};
